module.exports = __webpack_public_path__ + "img/Weapon_206.75ed3ca7.png";